import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "sonner";

// Layout
import AdminLayout from "./components/layout/AdminLayout";

// Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import MasterTable from "./pages/MasterTable";
import Products from "./pages/Products";
import PrascoProducts from "./pages/PrascoProducts";
import Inquiries from "./pages/Inquiries";
import Leads from "./pages/Leads";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected routes */}
          <Route element={<AdminLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/master/:type" element={<MasterTable />} />
            <Route path="/products" element={<Products />} />
            <Route path="/prasco-products" element={<PrascoProducts />} />
            <Route path="/inquiries/:type" element={<Inquiries />} />
            <Route path="/leads" element={<Leads />} />
          </Route>
          
          {/* Redirect root to dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          
          {/* Catch all - redirect to dashboard */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
